import { createTheme } from '@mui/material/styles';

/**
 * The MUI theme object supports custom properties, but requires
 * module augmentation. Theme and theme options interfaces may
 * eventually need to be moved to a 'd.ts' file. Links:
 *
 * https://mui.com/material-ui/customization/theming/#custom-variables
 * https://www.typescriptlang.org/docs/handbook/declaration-merging.html#module-augmentation
 */
declare module '@mui/material/styles' {
  interface Palette {
    tertiary: Palette['primary'];
  }
  interface PaletteOptions {
    tertiary?: PaletteOptions['primary'];
  }
  interface PaletteColor {
    lighter?: string;
    darker?: string;
  }
  interface SimplePaletteColorOptions {
    lighter?: string;
    darker?: string;
  }
}

/**
 * Any new palette colors need to be added here to
 * use the "color" prop on mui components.
 */
declare module '@mui/material' {
  interface ButtonPropsColorOverrides {
    tertiary: true;
  }

  interface SwitchPropsColorOverrides {
    tertiary: true;
  }
}

const theme = createTheme({
  typography: {
    fontFamily: 'Hind Guntur, Verdana, Arial, Helvetica, sans-serif',
  },
  palette: {
    primary: {
      main: '#48A5DD',
      contrastText: '#fff',
    },
    secondary: {
      main: '#6C6C6C',
    },
    tertiary: {
      main: '#8DC63F',
      contrastText: '#fff',
    },
    success: {
      main: '#77DD77',
    },
  },
});

export default theme;
